import { useLocation } from '@remix-run/react'
import { i18n } from '@lingui/core'
import { ExclamationCircleIcon } from '@heroicons/react/20/solid'

import { Highlighted, Paragraph } from '../text/Text'
import { Button } from '../form/Button'
import Card from '../ui/Card'

export const ErrorSubpage = () => {
  const { pathname } = useLocation()

  return (
    <Card variant="info" className="flex row gap-x-6 md:gap-x-8">
      <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-accent-muted sm:mx-0 sm:h-10 sm:w-10">
        <ExclamationCircleIcon className="h-6 w-6 text-brand" aria-hidden="true" />
      </div>
      <div>
        <Highlighted className="mb-4">{i18n._('Leider ist ein Fehler aufgetreten.')}</Highlighted>
        <Paragraph>
          {i18n._(
            'Bitte versuchen Sie es erneut. Laden Sie dazu die Seite neu, oder versuchen Sie es später noch einmal.'
          )}
        </Paragraph>
        <div className="mt-5 sm:mt-4">
          <Button
            as="a"
            align="left"
            href={pathname}
            className="w-max"
            label={i18n._('Neu laden')}
            size="small"
          />
        </div>
      </div>
    </Card>
  )
}
